import { FieldProps } from 'formik';
import { get } from 'lodash-es';
import * as React from 'react';
import { ChangeEvent, FocusEvent } from 'react';
import TextInput from '../TextInput/TextInput';

interface IOwnProps {
  id: string;
  name: string;
  type: 'number' | 'text' | 'password' | 'hidden' | 'tel' | 'email';
  defaultValue: string;
  onChange: (event: ChangeEvent<any>) => void;
  onBlur: (event: FocusEvent<any>) => void;
}

const InputField: React.SFC<FieldProps<any> & IOwnProps> = ({
  field,
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <TextInput
      {...field}
      {...props}
      touched={get(touched, field.name)}
      errors={get(errors, field.name)}
      onChange={(event: ChangeEvent<any>) => {
          if (props.onChange) {
            props.onChange(event);
          }
          field.onChange(event);
      }}
      onBlur={(event: FocusEvent<any>) => {
        if (props.onBlur) {
          props.onBlur(event);
        }
        field.onBlur(event);
    }}
    />
  );
};

export default InputField;
